/* Corail Wedding - animations, curseur corail, preloader */
(function () {
  if (window.corailScripts) return;
  window.corailScripts = true;

  var mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Empecher le navigateur de restaurer la position de scroll au rafraichissement ---------- */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  (function corrigerScrollRafraichissement() {
    try {
      var entrees = performance.getEntriesByType('navigation');
      var estRafraichissement = entrees.length
        ? entrees[0].type === 'reload'
        : !!(performance.navigation && performance.navigation.type === 1);
      if (estRafraichissement) {
        window.scrollTo(0, 0);
        window.addEventListener('load', function () {
          window.scrollTo(0, 0);
        });
      }
    } catch (e) {}
  })();

  /* ---------- Apparition au defilement ---------- */
  function toutAfficher() {
    document.querySelectorAll('.cw-reveal, .cw-photo-reveal').forEach(function (el) {
      el.classList.add('cw-vu');
    });
  }

  function demarrerRevelation() {
    if (mouvementReduit.matches || !('IntersectionObserver' in window)) {
      toutAfficher();
      return;
    }
    var observateur = new IntersectionObserver(
      function (entrees) {
        entrees.forEach(function (entree) {
          if (entree.isIntersecting) {
            entree.target.classList.add('cw-vu');
            observateur.unobserve(entree.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    document
      .querySelectorAll('.cw-reveal:not(.cw-vu), .cw-photo-reveal:not(.cw-vu)')
      .forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
          el.classList.add('cw-vu');
        } else {
          observateur.observe(el);
        }
      });
  }

  /* ---------- Curseur corail (ordinateur uniquement, couleur adaptative) ---------- */
  function demarrerCurseur() {
    if (document.getElementById('cw-curseur')) return;
    var modele = document.getElementById('cw-curseur-modele');
    if (!modele) return;

    /* Uniquement avec une souris ou un pavé tactile : jamais sur mobile ni tablette */
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var curseur = document.createElement('div');
    curseur.id = 'cw-curseur';
    curseur.setAttribute('aria-hidden', 'true');
    curseur.innerHTML = modele.innerHTML;
    document.body.appendChild(curseur);
    document.body.classList.add('cw-curseur-actif');

    var ECHELLE_REPOS = 0.72;
    var ECHELLE_ACTIF = 1;
    var cibleX = window.innerWidth / 2, cibleY = window.innerHeight / 2;
    var x = cibleX, y = cibleY;
    var echelle = ECHELLE_REPOS, cibleEchelle = ECHELLE_REPOS;
    var visible = false, aVerifier = true;
    var theme = '';

    /* --- Lecture de la couleur sous le curseur --- */
    function lireRgb(valeur) {
      var m = valeur && valeur.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s\/]+([\d.]+%?))?/);
      if (!m) return null;
      var a = m[4] === undefined ? 1 : (m[4].indexOf('%') > -1 ? parseFloat(m[4]) / 100 : parseFloat(m[4]));
      return { r: +m[1], g: +m[2], b: +m[3], a: a };
    }
    function luminance(c) {
      function canal(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
      return 0.2126 * canal(c.r) + 0.7152 * canal(c.g) + 0.0722 * canal(c.b);
    }
    function fondSous(px, py) {
      var el = document.elementFromPoint(px, py);
      while (el && el !== document.documentElement) {
        var force = el.getAttribute && el.getAttribute('data-cw-curseur');
        if (force === 'clair') return 'sombre';
        if (force === 'fonce') return 'clair';
        var tag = el.tagName;
        if (tag === 'IMG' || tag === 'VIDEO' || tag === 'PICTURE' || tag === 'IFRAME' || tag === 'CANVAS') return 'image';
        var st = window.getComputedStyle(el);
        var img = st.backgroundImage;
        if (img && img !== 'none') {
          if (img.indexOf('url(') > -1) return 'image';
          var premiere = lireRgb(img);
          if (premiere && premiere.a > 0.4) return luminance(premiere) < 0.3 ? 'sombre' : 'clair';
        }
        var fond = lireRgb(st.backgroundColor);
        if (fond && fond.a > 0.4) return luminance(fond) < 0.3 ? 'sombre' : 'clair';
        el = el.parentElement;
      }
      var corps = lireRgb(window.getComputedStyle(document.body).backgroundColor);
      return corps && corps.a > 0.4 && luminance(corps) < 0.3 ? 'sombre' : 'clair';
    }
    function appliquerTheme() {
      var nouveau = fondSous(cibleX, cibleY);
      if (nouveau === theme) return;
      curseur.classList.remove('cw-curseur--sur-clair', 'cw-curseur--sur-sombre', 'cw-curseur--sur-image');
      curseur.classList.add('cw-curseur--sur-' + nouveau);
      theme = nouveau;
    }

    function estCliquable(el) {
      return !!(el && el.closest && el.closest('a, button, summary, label, [role="button"], .cw-cartes__lien'));
    }

    document.addEventListener('mousemove', function (e) {
      cibleX = e.clientX; cibleY = e.clientY; aVerifier = true;
      if (!visible) {
        x = cibleX; y = cibleY;
        curseur.classList.add('cw-curseur--visible'); visible = true;
      }
    }, { passive: true });
    document.addEventListener('mouseleave', function () {
      curseur.classList.remove('cw-curseur--visible'); visible = false;
    });
    document.addEventListener('mouseover', function (e) {
      cibleEchelle = estCliquable(e.target) ? ECHELLE_ACTIF : ECHELLE_REPOS;
    });
    document.addEventListener('mousedown', function () { curseur.classList.add('cw-curseur--presse'); });
    document.addEventListener('mouseup', function () { curseur.classList.remove('cw-curseur--presse'); });
    window.addEventListener('scroll', function () { aVerifier = true; }, { passive: true });

    (function boucle() {
      var douceur = mouvementReduit.matches ? 1 : 0.2;
      x += (cibleX - x) * douceur;
      y += (cibleY - y) * douceur;
      echelle += (cibleEchelle - echelle) * (mouvementReduit.matches ? 1 : 0.18);
      if (aVerifier && visible) { appliquerTheme(); aVerifier = false; }
      curseur.style.transform =
        'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) translate(-50%,-50%) scale(' + echelle.toFixed(3) + ')';
      window.requestAnimationFrame(boucle);
    })();
  }

  /* ---------- Page de chargement ---------- */
  function demarrerPreloader() {
    var voile = document.getElementById('cw-preloader');
    if (!voile) return;

    var duree = parseInt(voile.getAttribute('data-duree'), 10) || 2200;
    var dejaVu = false;

    if (voile.getAttribute('data-une-fois') === 'true') {
      try {
        dejaVu = window.sessionStorage.getItem('cw-preloader-vu') === '1';
      } catch (e) {
        dejaVu = false;
      }
    }

    if (dejaVu || mouvementReduit.matches) {
      voile.remove();
      document.documentElement.classList.remove('cw-chargement');
      return;
    }

    voile.classList.add('cw-preloader--anime');

    window.setTimeout(function () {
      voile.classList.add('cw-preloader--sortie');
      document.documentElement.classList.remove('cw-chargement');
      try {
        window.sessionStorage.setItem('cw-preloader-vu', '1');
      } catch (e) {}
      window.setTimeout(function () {
        if (voile.parentNode) voile.remove();
        demarrerRevelation();
      }, 1100);
    }, duree);
  }

  /* ---------- Bandeau cookies ---------- */
  function demarrerCookies() {
    var bandeau = document.getElementById('cw-cookies');
    if (!bandeau) return;

    var choix = null;
    try {
      choix = window.localStorage.getItem('cw-cookies-choix');
    } catch (e) {}

    if (choix) return;

    window.setTimeout(function () {
      bandeau.classList.add('cw-cookies--visible');
    }, 1400);

    bandeau.addEventListener('click', function (e) {
      var bouton = e.target.closest('[data-cw-cookies]');
      if (!bouton) return;
      var valeur = bouton.getAttribute('data-cw-cookies');
      try {
        window.localStorage.setItem('cw-cookies-choix', valeur);
      } catch (err) {}
      if (valeur === 'accepte' && window.Shopify && window.Shopify.customerPrivacy) {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(true, function () {});
        } catch (err) {}
      }
      bandeau.classList.remove('cw-cookies--visible');
      window.setTimeout(function () {
        if (bandeau.parentNode) bandeau.remove();
      }, 700);
    });
  }

  function demarrer() {
    demarrerPreloader();
    demarrerRevelation();
    demarrerCurseur();
    demarrerCookies();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(demarrerRevelation, 40);
  });
  document.addEventListener('shopify:section:select', toutAfficher);

  mouvementReduit.addEventListener('change', function () {
    if (mouvementReduit.matches) toutAfficher();
  });
})();
